module.exports = __webpack_public_path__ + "img/36.cf93368e.png";